import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SignInPage } from '@/features/auth/SignInPage';
import { isSafeNext } from '@/features/auth/safeNext';

export const Route = createFileRoute('/sign-in')({
  validateSearch: z.object({ next: z.string().refine(isSafeNext).optional() }),
  component: SignInPage,
});
